APP.news = function () {
	const el = $('.table-filter');
	const filterName = el.data('filter-name');
	const filterPlaceholder = el.data('filter-placeholder');

	function init() {
		if (el.length === 0) return;

		el.filterTable({
			label: filterName,
			placeholder: filterPlaceholder,
		});
	}

	init();
};
